var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 21.0005V13.0005C15 12.7352 14.8946 12.4809 14.7071 12.2933C14.5196 12.1058 14.2652 12.0005 14 12.0005H10C9.73478 12.0005 9.48043 12.1058 9.29289 12.2933C9.10536 12.4809 9 12.7352 9 13.0005V21.0005M3 10.0005C2.99993 9.70952 3.06333 9.42208 3.18579 9.15817C3.30824 8.89427 3.4868 8.66025 3.709 8.47246L10.709 2.47346C11.07 2.16836 11.5274 2.00098 12 2.00098C12.4726 2.00098 12.93 2.16836 13.291 2.47346L20.291 8.47246C20.5132 8.66025 20.6918 8.89427 20.8142 9.15817C20.9367 9.42208 21.0001 9.70952 21 10.0005V19.0005C21 19.5309 20.7893 20.0396 20.4142 20.4147C20.0391 20.7897 19.5304 21.0005 19 21.0005H5C4.46957 21.0005 3.96086 20.7897 3.58579 20.4147C3.21071 20.0396 3 19.5309 3 19.0005V10.0005Z",
    stroke: "#054E5A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.550ccf9f5a99a5edde44200e3555af4d.svg";
export { ForwardRef as ReactComponent };